import React from "react";
import { ASSETS } from "@/lib/brand";
import { useApp } from "@/context/AppContext";
import { qrUrl } from "@/lib/api";

// Presents the authoritative supplied blue membership card. The card art is NOT redesigned —
// member details are overlaid as an editorial caption scrim beneath the card image.
export function MemberCard({ member, showQr = true }) {
  const { t, lang } = useApp();
  const name = `${member.first_name || ""} ${member.surname || ""}`.trim().toUpperCase();
  const number = member.membership_number || "—";
  const renewal = member.renewal_date ? new Date(member.renewal_date).toLocaleDateString(lang === "it" ? "it-IT" : "en-GB", { day: "2-digit", month: "short", year: "numeric" }) : "—";

  return (
    <div className="w-full max-w-sm mx-auto" data-testid="my-card-blue-card-container">
      <div className="relative rounded-2xl overflow-hidden gold-border" style={{ boxShadow: "0 24px 60px -20px rgba(0,0,40,0.8), 0 0 40px -10px rgba(40,80,220,0.25)" }}>
        <img src={ASSETS.blueCard} alt="Caught Up International Membership Card" className="w-full block" />
        <div className="absolute inset-x-0 bottom-0 p-4 pt-10" style={{ background: "linear-gradient(to top, rgba(5,8,25,0.95), rgba(5,8,25,0.55) 55%, transparent)" }}>
          <div className="flex items-start justify-between gap-3">
            <div className="min-w-0">
              <div className="eyebrow" style={{ color: "rgba(212,175,55,0.85)" }}>{t("member_no")}</div>
              <div className="font-mono-cu text-sm tracking-[0.12em] gold-text truncate">{number}</div>
            </div>
            <div className="text-right shrink-0">
              <span className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-[0.6rem] font-mono-cu uppercase tracking-[0.15em]" style={{ color: "#10B981", border: "1px solid #10B98155", background: "#10B98115" }}>
                <span className="w-1.5 h-1.5 rounded-full" style={{ background: "#10B981" }} />
                {member.status === "active" ? (lang === "it" ? "Attivo" : "Active") : "—"}
              </span>
              <div className="eyebrow mt-2" style={{ color: "rgba(212,175,55,0.85)" }}>{t("valid_until")}</div>
              <div className="font-mono-cu text-[0.72rem] text-white/90">{renewal}</div>
            </div>
          </div>
          <div className="font-serif-cu text-base text-white/95 mt-2.5 tracking-wide leading-tight break-words" data-testid="my-card-member-name">{name || "—"}</div>
        </div>
      </div>

      {showQr && member.status === "active" && (
        <div className="cu-card mt-5 p-5 flex items-center gap-4 fade-up">
          <div className="bg-white rounded-lg p-1.5 shrink-0">
            <img src={qrUrl()} alt="Member verification QR" className="w-24 h-24" data-testid="member-qr-code" />
          </div>
          <div>
            <div className="eyebrow">{t("verification")}</div>
            <p className="text-sm text-[color:var(--cu-muted)] mt-1.5 leading-relaxed">{t("show_at_venue")}</p>
          </div>
        </div>
      )}
    </div>
  );
}
